export default __webpack_public_path__ + "media/images/dashboard_icons/paintbrush-46506075a1b845e3b14fff992d2be801.svg";